// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2Ud5F","file":"styles_file__1xx5i"};